// src/TermsConsent.jsx
import React, { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { doc, getDoc, setDoc, serverTimestamp, onSnapshot } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { CURRENT_TERMS_VERSION } from "./termsConfig";

const TRELLI_GREEN = "#00B074";

export default function TermsConsent() {
  const nav = useNavigate();
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [userDoc, setUserDoc] = useState(null);

  useEffect(() => {
    const u = auth.currentUser;
    if (!u) return;
    const unsub = onSnapshot(doc(db, "users", u.uid), (snap) => {
      setUserDoc(snap.exists() ? snap.data() : {});
    });
    return () => unsub();
  }, []);

  const planTier = userDoc?.planTier || null;

  async function accept() {
    setErr("");
    setBusy(true);
    try {
      const u = auth.currentUser;
      if (!u) throw new Error("You must be signed in.");
      const ref = doc(db, "users", u.uid);

      // Ensure we have a doc (in case of race with signup)
      const snap = await getDoc(ref);
      const prior = snap.exists() ? snap.data() : {};

      await setDoc(ref, {
        legal: {
          termsVersionAccepted: CURRENT_TERMS_VERSION,
          termsAcceptedAt: serverTimestamp(),
          esignConsent: true,
          planAtAcceptance: planTier || prior.planTier || null,
        },
        updatedAt: new Date(),
      }, { merge: true });

      // Continue to MFA step
      nav("/signup/mfa");
    } catch (e) {
      setErr(e?.message || String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={wrap}>
      <div style={card}>
        <h2 style={{ marginTop: 0 }}>Review & accept Terms</h2>
        <p style={{ color: "#475467" }}>
          Please review and accept our Terms &amp; Conditions to continue.
        </p>

        {err && <div style={errorBox}>{err}</div>}

        <div style={{ background:"#fafafa", border:"1px solid #eee", borderRadius:12, padding:12 }}>
          <label style={{ display:"flex", alignItems:"flex-start", gap:10 }}>
            <input
              type="checkbox"
              checked={checked}
              onChange={e => setChecked(e.target.checked)}
              style={{ marginTop: 3 }}
            />
            <span style={{ fontSize:14, color:"#333" }}>
                I agree to the <a
                    href={typeof window !== "undefined" ? new URL("/terms/", window.location.origin).toString() : "/terms/"}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Trelli Terms &amp; Conditions.</a> I consent to electronic disclosures and communications.
            </span>
          </label>
        </div>

        <div style={{ display:"flex", gap:8, marginTop:12 }}>
          <button
            onClick={accept}
            disabled={!checked || busy}
            style={primary}
          >
            {busy ? "Saving…" : "I Agree, Continue"}
          </button>
          <button
            onClick={() => nav("/signup")}
            style={linkBtn}
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
}

/* styles */
const wrap = {
  minHeight: "100dvh",
  display: "grid",
  placeItems: "center",
  background:
    "radial-gradient(1200px 600px at 10% -20%, rgba(0,176,116,0.08), transparent 50%), radial-gradient(800px 400px at 110% 120%, rgba(244,197,66,0.06), transparent 40%), #f8faf9",
  padding: 24
};
const card = {
  width: "100%",
  maxWidth: 520,
  background: "#fff",
  borderRadius: 16,
  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  padding: 24
};
const primary = {
  height: 44, border: "none", borderRadius: 12,
  background: TRELLI_GREEN, color: "#fff", fontWeight: 800, fontSize: 15, cursor: "pointer",
  boxShadow: "0 4px 10px rgba(0,176,116,0.25)", padding: "0 16px"
};
const linkBtn = {
  height: 44, borderRadius: 12, border: "1px solid #E5E7EB",
  background: "#fff", color: "#111", fontWeight: 700, cursor: "pointer", padding: "0 16px"
};
const errorBox = {
  border: "1px solid #ef9a9a",
  background: "#ffebee",
  color: "#b71c1c",
  borderRadius: 10,
  padding: "10px 12px",
  margin: "12px 0",
  fontSize: 14,
};
